import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/jobbuddymascot.webp",
  alt: "JobBuddy Logo",
  class: "navbar-logo",
  width: "32",
  height: "32"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "navbar-brand fw-bold mb-0" }, [
  /*#__PURE__*/_createTextVNode("Job"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-accent" }, "Buddy")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  class: "navbar-toggler",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#navbarText"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "navbar-toggler-icon" })
], -1)
const _hoisted_5 = {
  id: "navbarText",
  class: "collapse navbar-collapse"
}
const _hoisted_6 = { class: "navbar-nav ms-auto align-items-center" }
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = {
  key: 1,
  class: "nav-item"
}
const _hoisted_9 = { class: "nav-item d-none d-md-block ms-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-right ps-2" }, null, -1)
const _hoisted_11 = {
  key: 1,
  class: "dropdown"
}
const _hoisted_12 = {
  type: "button",
  class: "btn btn-light dropdown-toggle px-4 rounded-pill",
  "data-bs-toggle": "dropdown"
}
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1)
const _hoisted_16 = { class: "bg-transparent min-vh-100" }
const _hoisted_17 = {
  key: 1,
  class: "footer py-5"
}
const _hoisted_18 = { class: "container" }
const _hoisted_19 = { class: "row g-4" }
const _hoisted_20 = /*#__PURE__*/_createStaticVNode("<div class=\"col-lg-4 col-md-6\"><div class=\"footer-brand mb-4\"><h2 class=\"mb-0 fw-bold\">Job<span class=\"text-primary\">Buddy</span></h2><p class=\"text-muted mt-2 mb-0\">AI tools to get you hired faster</p></div><div class=\"social-links mt-3\"><a href=\"https://twitter.com/jobbuddytech\" target=\"_blank\" class=\"me-3\"><i class=\"bi bi-twitter-x\"></i></a><a href=\"https://www.linkedin.com/company/104235434\" target=\"_blank\" class=\"me-3\"><i class=\"bi bi-linkedin\"></i></a><a href=\"https://www.producthunt.com/@jobbuddy\" target=\"_blank\"><i class=\"bi bi-product-hunt\"></i></a></div></div>", 1)
const _hoisted_21 = { class: "col-lg-3 col-md-6 offset-lg-1" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h6", { class: "fw-bold mb-3" }, "Resources", -1)
const _hoisted_23 = { class: "list-unstyled" }
const _hoisted_24 = { class: "mb-2" }
const _hoisted_25 = { class: "mb-2" }
const _hoisted_26 = { class: "mb-2" }
const _hoisted_27 = { class: "mb-2" }
const _hoisted_28 = { class: "col-lg-2 col-md-6" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h6", { class: "fw-bold mb-3" }, "Company", -1)
const _hoisted_30 = { class: "list-unstyled" }
const _hoisted_31 = { class: "mb-2" }
const _hoisted_32 = { class: "mb-2" }
const _hoisted_33 = { class: "mb-2" }
const _hoisted_34 = /*#__PURE__*/_createStaticVNode("<div class=\"col-lg-2 col-md-6\"><h6 class=\"fw-bold mb-3\">More</h6><ul class=\"list-unstyled\"><li class=\"mb-2\"><a href=\"mailto:hello@jobbuddytech.com\">Contact Us</a></li><li class=\"mb-2\"><a href=\"https://jobbuddytech.getrewardful.com/\" target=\"_blank\">Affiliates</a></li></ul></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_AuthenticatedLayout = _resolveComponent("AuthenticatedLayout")!

  return (_openBlock(), _createElementBlock("div", {
    id: "app",
    class: _normalizeClass({
      'has-navbar': !$setup.showSidebar,
      'home-page': _ctx.$route.name === 'Home',
    })
  }, [
    (!$setup.showSidebar)
      ? (_openBlock(), _createElementBlock("nav", {
          key: 0,
          class: _normalizeClass(["navbar navbar-expand-lg fixed-top", {
        'navbar-landing': _ctx.$route.name === 'Home',
        'navbar-light bg-white shadow-sm': _ctx.$route.name !== 'Home',
      }])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_router_link, {
              to: "/",
              class: "navbar-brand-container d-flex align-items-center"
            }, {
              default: _withCtx(() => [
                _hoisted_2,
                _hoisted_3
              ]),
              _: 1
            }),
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("ul", _hoisted_6, [
                _createElementVNode("li", _hoisted_7, [
                  _createVNode(_component_router_link, {
                    to: "/subscribe",
                    class: "nav-link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Pricing")
                    ]),
                    _: 1
                  })
                ]),
                (!$setup.isAuthenticated)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      class: "nav-item",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.login()))
                    }, [
                      _createVNode(_component_router_link, {
                        to: "",
                        class: "nav-link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Login")
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("li", _hoisted_8, [
                      _createVNode(_component_router_link, {
                        to: "/dashboard",
                        class: "nav-link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Dashboard")
                        ]),
                        _: 1
                      })
                    ])),
                _createElementVNode("li", _hoisted_9, [
                  (!$setup.isAuthenticated)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "btn btn-light rounded-pill px-4",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.signup()))
                      }, [
                        _createTextVNode(" Sign up "),
                        _hoisted_10
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("button", _hoisted_12, [
                          ($setup.isAuthenticated)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                width: "25",
                                class: "rounded-circle me-2",
                                src: $setup.user.picture
                              }, null, 8, _hoisted_13))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString($setup.user.name), 1)
                        ]),
                        _createElementVNode("ul", _hoisted_14, [
                          _createElementVNode("li", null, [
                            _createVNode(_component_router_link, {
                              to: { name: 'Dashboard' },
                              class: "dropdown-item"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Dashboard ")
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("li", null, [
                            _createVNode(_component_router_link, {
                              to: { name: 'Profile' },
                              class: "dropdown-item"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Profile ")
                              ]),
                              _: 1
                            })
                          ]),
                          _hoisted_15,
                          _createElementVNode("li", null, [
                            _createElementVNode("a", {
                              href: "#",
                              class: "dropdown-item",
                              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.logoutUser && $setup.logoutUser(...args)))
                            }, "Logout")
                          ])
                        ])
                      ]))
                ])
              ])
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("body", _hoisted_16, [
      _createVNode(_component_AuthenticatedLayout, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      })
    ]),
    (!$setup.showSidebar)
      ? (_openBlock(), _createElementBlock("footer", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("ul", _hoisted_23, [
                  _createElementVNode("li", _hoisted_24, [
                    _createVNode(_component_router_link, { to: { name: 'Courses' } }, {
                      default: _withCtx(() => [
                        _createTextVNode("Free Courses Guide 2025")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_25, [
                    _createVNode(_component_router_link, { to: { name: 'ResumeExamples' } }, {
                      default: _withCtx(() => [
                        _createTextVNode("Resume Examples")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_26, [
                    _createVNode(_component_router_link, { to: { name: 'CoverLetterExamples' } }, {
                      default: _withCtx(() => [
                        _createTextVNode("Cover Letter Examples")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_27, [
                    _createVNode(_component_router_link, { to: { name: 'ChatGPTBlog' } }, {
                      default: _withCtx(() => [
                        _createTextVNode("JobBuddy vs ChatGPT")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("ul", _hoisted_30, [
                  _createElementVNode("li", _hoisted_31, [
                    _createVNode(_component_router_link, { to: { name: 'TermsOfService' } }, {
                      default: _withCtx(() => [
                        _createTextVNode("Terms of Service")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_32, [
                    _createVNode(_component_router_link, { to: { name: 'PrivacyPolicy' } }, {
                      default: _withCtx(() => [
                        _createTextVNode("Privacy Policy")
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", _hoisted_33, [
                    _createVNode(_component_router_link, { to: { name: 'Subscribe' } }, {
                      default: _withCtx(() => [
                        _createTextVNode("Pricing")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _hoisted_34
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}